import { render, staticRenderFns } from "./RelationImportLink.vue?vue&type=template&id=2dfa3fca"
import script from "./RelationImportLink.vue?vue&type=script&lang=js"
export * from "./RelationImportLink.vue?vue&type=script&lang=js"
import style0 from "./RelationImportLink.vue?vue&type=style&index=0&id=2dfa3fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports